export const GLOBAL_BRANCHES_RESET_STATE = 'GLOBAL_BRANCHES_RESET_STATE';
export const GLOBAL_BRANCHES_CURRENT_ITEM = 'GLOBAL_BRANCHES_CURRENT_ITEM';

export const GLOBAL_BRANCHES_REQUEST_LOADING = 'GLOBAL_BRANCHES_REQUEST_LOADING';
export const GLOBAL_BRANCHES_REQUEST_SUCCESS = 'GLOBAL_BRANCHES_REQUEST_SUCCESS';
export const GLOBAL_BRANCHES_REQUEST_FAILED = 'GLOBAL_BRANCHES_REQUEST_FAILED';

export const GLOBAL_BRANCHES_CURRENT_ACTION = 'GLOBAL_BRANCHES_CURRENT_ACTION';
export const GLOBAL_BRANCHES_RESET_ACTION = 'GLOBAL_BRANCHES_RESET_ACTION';